// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getAuth,
  initializeAuth,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { Capacitor } from "@capacitor/core";

const firebaseConfig = {
  apiKey: "AIzaSyDqVOcEfXrUlP-53iUILrcJLnCSJAiCdP4",
  authDomain: "vibe-check-c6433.firebaseapp.com",
  projectId: "vibe-check-c6433",
  storageBucket: "vibe-check-c6433.firebasestorage.app",
  messagingSenderId: "161052244771",
  appId: "1:161052244771:web:6e083d86e1f49327436a96",
  measurementId: "G-F0K8909YJ3",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let auth;
// auth persistence
if (Capacitor.isNativePlatform()) {
  auth = initializeAuth(app, {
    persistence: browserLocalPersistence,
  });
} else {
  auth = getAuth(app);
}

const db = getFirestore(app);

// Initialize Firebase Functions with explicit region
const functions = getFunctions(app, "us-central1");

// Connect to emulator in development (uncomment if needed)
// if (process.env.NODE_ENV === 'development') {
//   connectFunctionsEmulator(functions, "localhost", 5001);
// }

export { auth, db, functions };
